

// Define reminder options
export const reminderOptions = (t: any, key: string = 'vaccinations') => [
  { value: 0, label: t(`reminder.options.${key}.day`) },
  { value: 1, label: t('reminder.options.1') },
  { value: 2, label: t('reminder.options.2') },
  { value: 3, label: t('reminder.options.3') },
];

export const getReminderOptions = (dueDate: Date, t: any, key: string = 'vaccinations') => {
  if (!dueDate) return [{ value: 0 + "", label: t(`reminder.options.${key}.day`) }];

  // Calculate days between today and due date
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time part for accurate day calculation
  const dueDateCopy = new Date(dueDate);
  dueDateCopy.setHours(0, 0, 0, 0);

  // Calculate difference in days
  const diffTime = dueDateCopy.getTime() - today.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  // Create options based on days difference (up to 3 days before)
  const options = [{ value: 0 + "", label: t(`reminder.options.${key}.day`) }];

  // Add options for 1, 2, 3 days before if applicable
  for (let i = 1; i <= Math.min(3, diffDays); i++) {
    options.push({ value: i + "", label: t(`reminder.options.${i}`) });
  }

  return options;
};